<template>
    <b-form @submit.prevent="submit" inline>
      <b-form-group label="Carrier" class="mr-3 carrier">
        <CarrierPicker @input="setCarrier" />
      </b-form-group>
      <b-form-group label="Pickup Date" class="mr-3 cdate">
        <flat-pickr class="" v-model="form.pickupDate" placeholder="Select date" :config="fltConfig" value="" />
      </b-form-group>
      <b-form-group label="Pickup date type" class="mr-3">
        <b-select class="custom-select" v-model="form.pickupDateTypeId" :options="dateTypeOptions" />
      </b-form-group>
      <b-form-group label="Delivery Date" class="mr-3 cdate">
        <flat-pickr class="" v-model="form.deliveryDate" placeholder="Select date" ref="datePicker" :config="fltConfig2" value="" />
      </b-form-group>
      <b-form-group label="Delivery date type" class="mr-3">
        <b-select class="custom-select" v-model="form.deliveryDateTypeId" :options="dateTypeOptions" />
      </b-form-group>
      <b-form-group label="Transport type" class="mr-3">

        <b-select class="custom-select" v-model="form.transportTypeId" :options="transportTypeOptions" />
      </b-form-group>
      <b-form-group label="Carrier Pay" class="mr-3">
        <b-input class="cpay" v-model="form.carrierPay" type="text" :number="true" />
      </b-form-group>

  
      <b-form-group label="Note" class="mr-3">
        <b-input v-model="form.note" type="text" />  
      </b-form-group>
      <button class="btn btn-primary mt-4" :disabled="formSubmit ? 'disabled' : undefined">Create</button>
    </b-form>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import CarrierPicker from '../CarrierPicker';
import dateTypesMixin from '@/mixins/dateTypes';
import transportTypesMixin from '@/mixins/transportTypes';

export default {
  name: 'AddNewTruckerForm',
  mixins: [dateTypesMixin, transportTypesMixin],
  components: {
    CarrierPicker,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    let self = this;
    return {
      formSubmit: false,
      fltConfig: {
        inline: false,
        enableTime: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'm/d/Y',
        allowInput: false,
        onChange: function () {
          if (!self.form.deliveryDate) {
            self.$refs.datePicker.fp.open();
          }
        },
      },
      fltConfig2: {
        inline: false,
        enableTime: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'm/d/Y',
        allowInput: false,
        minDate: this.order.moveDate,
      },
      form: {
        id: null,
        leadId: this.order.id,
        pickupDate: this.order.moveDate,
        pickupDateTypeId: this.order.pickupDateTypeId,
        deliveryDate: null,
        deliveryDateTypeId: this.order.deliveryDateTypeId,
        transportTypeId: this.order.transportTypeId,
        carrierPay: this.order.carrierPay ? parseInt(this.order.carrierPay) : null,
        carrierId: null,
        note: null,
      },
      transportTypeOptions: [{ value: null, text: '-' }],
      dateTypeOptions: [{ value: null, text: '-' }],
    };
  },
  created() {
    this.transportTypeOptions = this.transportTypeOptions.concat(this.transportTypes.map(x => { x.text = x.label; return x; }));
    this.dateTypeOptions = this.dateTypeOptions.concat(this.dateTypes.map(x => { x.text = x.label; return x; }));
  },
  methods: {
    setCarrier(carrier) {
      this.form.carrierId = carrier ? carrier.id : null;
    },
    async submit() {
      this.formSubmit = true;
      const response = await ApiClient.leads.offers.post({ leadId: this.order.id, body: Object.assign({}, this.form) });
      if (response.status === 200) {
        this.reset();
        this.$emit('refresh');
      }
      this.formSubmit = false;
    },
    reset() {
      this.form = Object.assign(this.form, {
        id: null,
        leadId: this.order.id,
        pickupDate: this.order.moveDate,
        pickupDateTypeId: this.order.pickupDateTypeId,
        deliveryDate: null,
        deliveryDateTypeId: this.order.deliveryDateTypeId,
        transportTypeId: this.order.transportTypeId,
        carrierPay: this.order.carrierPay,
        carrierId: null,
        note: null,
      });
    },
  },
  watch: {
    'form.pickupDate': function (val) {
      this.fltConfig2.minDate = val;
    },
  },
};
</script>
